import { z } from "zod";
import { EMAIL_INVALID, EMAIL_REQUIRED } from "@/constants/forms";

export const ForgotPasswordSchema = z
  .object({
    email: z
      .string({
        invalid_type_error: EMAIL_INVALID,
        required_error: EMAIL_REQUIRED,
      })
      .email({ message: EMAIL_INVALID }),
  })
  .required();

export type ForgotPasswordType = z.infer<typeof ForgotPasswordSchema>;
